import { EventEmitter, inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UdlOverlapToolContainerService } from 'src/app/esa-assessment/udl-overlap-tool/udl-overlap-tool-container.service';
import { Constants } from 'src/app/shared/utils/constants';
import { UdlModelService } from '../../udl-model.service';

@Injectable({
    providedIn: 'root'
})
export class EPAProjectRunService {
    private apiUrl: string = environment.BAMS_Api_URL;
    private udlOverlapToolContainerService: UdlOverlapToolContainerService = inject(UdlOverlapToolContainerService);
    private modelService: UdlModelService = inject(UdlModelService);
    private getStatusInterval: number = 30000; // 30 seconds
    private intervalStarted: boolean = false;
    private projectPk: number = 0;
    
    public isProjectRunning: boolean = false;
    public isProjectRunningEvent = new EventEmitter<boolean>();
    public projectStatusUpdatedEvent = new EventEmitter<number>();

    constructor(private httpClient: HttpClient) {
        this.udlOverlapToolContainerService.projectPkAvailableEvent.subscribe((projectPk) => { 
            this.projectPk = projectPk;
            this.getRunStatus() // get the status initially
            this.getStatusOninterval();
        });

        this.isProjectRunningEvent.subscribe((isRunning: boolean) => {
            this.isProjectRunning = isRunning;
        });

        this.projectStatusUpdatedEvent.subscribe((statusId: number) => {
            this.isProjectRunningEvent.emit(statusId == Constants.PROJECT_STATUS_ID.IN_PROGRESS);
        });
    }

    public startRunIfAllowed() {
        if(this.projectPk === 0 || this.modelService.modelPk === 0 || this.isProjectRunning === true) {
            return;
        }

        const endpoint = `${this.apiUrl}api/projects/${this.projectPk}/epa/model/${this.modelService.modelPk}/run`;
        this.httpClient.post(endpoint, null).pipe(map((data: any) => data.Value)).subscribe(() => { 
            this.getRunStatus(); // once request returns, lets update the status
        });
        setTimeout(() => {
            this.getRunStatus(); // once we call the run project, lets update the status
        }, 1000);
    }

    private getStatusOninterval() {
        if(this.intervalStarted) return;
        this.intervalStarted = true;

        setInterval(() => {
            this.getRunStatus();
        }, this.getStatusInterval);
    }

    public getRunStatus() {
        if(this.projectPk === 0 || this.modelService.modelPk === 0) return;
        const endpoint = `${this.apiUrl}api/projects/${this.projectPk}/epa/model/${this.modelService.modelPk}/run/status`;
        this.httpClient.get(endpoint).pipe(map((data: any) => data.Value)).subscribe((data: any) => {
            this.projectStatusUpdatedEvent.emit(data.Status);
        });
    }

    public resetRunStatus() {
        if(this.projectPk === 0 || this.modelService.modelPk === 0 || this.isProjectRunning) return;
        const endpoint = `${this.apiUrl}api/projects/${this.projectPk}/epa/model/${this.modelService.modelPk}/run/reset`;
        this.httpClient.post(endpoint, null).pipe(map((data: any) => data.Value)).subscribe(() => {
            this.getRunStatus();
        });
    }
}